module.exports = __webpack_public_path__ + "img/finance9.8d9c5fb8.png";